import { action, makeAutoObservable, observable } from "mobx";
import Store from "./Store";

type DisplayStateProps = {
  displayWorkoutWindowOpen: boolean;
  addAthleteOn: boolean;
  addWorkoutModalOpen: boolean;
  menuOpen: boolean;
  workoutMode: WorkoutMode;
};

export type MineCoachListItem = {
  id: string;
  fullName: string;
  email: string;
  status: number | string;
};

export enum WorkoutMode {
  create,
  edit,
}

export default class CoachStore {
  mineAthletesList = observable.array();

  athletesList = observable.array();

  mineCoachesList: MineCoachListItem[] = [];

  currentAthleteId: string | undefined;

  displayState: DisplayStateProps = {
    addAthleteOn: false,
    displayWorkoutWindowOpen: false,
    addWorkoutModalOpen: false,
    menuOpen: false,
    workoutMode: WorkoutMode.create,
  };
  currentAthlete: any;

  setDisplayAddAthlete(isOpen: boolean) {
    this.displayState.addAthleteOn = isOpen;
  }

  setMineCoaches(items: MineCoachListItem[]) {
    this.mineCoachesList = items;
  }

  removeMineCoach(id: string) {
    this.mineCoachesList = this.mineCoachesList.filter((x) => x.id !== id);
  }

  setWorkoutMode(mode: WorkoutMode) {
    this.displayState.workoutMode = mode;
  }

  setWorkoutModalOpen(isOpen: boolean) {
    this.displayState.addWorkoutModalOpen = isOpen;
    console.log("setDisplayAddAthlete call");
  }

  setWorkoutInfoOpen(isOpen: boolean) {
    this.displayState.displayWorkoutWindowOpen = isOpen;
    console.log("setWorkoutInfoOpen called");
  }

  setMenuOpen(isOpen: boolean) {
    this.displayState.menuOpen = isOpen;
  }

  setCurrentAthlete(id: string) {
    if (!id) return;
    this.currentAthleteId = id;
    this.currentAthlete = this.mineAthletesList.find((x) => x.id === id);
  }

  constructor(private store: Store) {
    makeAutoObservable(this, {
      setDisplayAddAthlete: action.bound,
      setMineCoaches: action.bound,
      removeMineCoach: action.bound,
      setWorkoutMode: action.bound,
      setWorkoutModalOpen: action.bound,
      setMenuOpen: action.bound,
      setCurrentAthlete: action.bound,
      currentAthlete: observable,
      athletesList: observable,
    });
  }
}
